"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileCollectionFromZip = void 0;
const jszip_1 = __importDefault(require("jszip"));
const FileCollection_1 = require("./FileCollection");
/**
 * Create a FileCollection from a zip
 * @param zipContent
 * @returns
 */
async function fileCollectionFromZip(zipContent) {
    const jsZip = new jszip_1.default();
    const zip = await jsZip.loadAsync(zipContent);
    const fileCollectionItems = [];
    for (let key in zip.files) {
        const entry = zip.files[key];
        if (entry.dir)
            continue;
        fileCollectionItems.push({
            name: entry.name.replace(/^.*\//, ''),
            relativePath: entry.name,
            lastModified: entry.date.getTime(),
            // @ts-expect-error _data is not exposed because missing for folder   but it is really there
            size: entry._data.uncompressedSize,
            text: () => {
                return entry.async('text');
            },
            arrayBuffer: () => {
                return entry.async('arraybuffer');
            },
            stream: () => {
                return new ReadableStream({
                    start(controller) {
                        void entry.async('arraybuffer').then((arrayBuffer) => {
                            //todo the test are currently passing I don't know how to solve this
                            //@ts-expect-error to fix
                            controller.enqueue(arrayBuffer);
                            controller.close();
                        });
                    },
                });
            },
        });
    }
    return new FileCollection_1.FileCollection(fileCollectionItems);
}
exports.fileCollectionFromZip = fileCollectionFromZip;
//# sourceMappingURL=fileCollectionFromZip.js.map